import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common';

class MagstimTableDiagnoses extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
                { title: CurrentLang().edit_patient_diagnosis_code_label, property: 'CodeTypeIcd10' },
                { title: CurrentLang().edit_patient_primary_diagnosis_label, property: 'PrimaryDiagnosis'},
				{ title: CurrentLang().edit_patient_secondary_diagnosis_label, property: 'SecondaryDiagnosis'},	
				{ title: CurrentLang().settings_date, property: 'CreatedTime', formatter: this.formatDate},
			],
			data: data
		};
    }
    
    resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Type', '');
	}
}



export default MagstimTableDiagnoses;